import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-9020636c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    key: 0,
    class: "mobile-devices"
};
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("main", null, [
    /*#__PURE__*/ _createElementVNode("img", {
        src: "/logo.svg",
        alt: "Logo"
    }),
    /*#__PURE__*/ _createElementVNode("p", null, [
        /*#__PURE__*/ _createTextVNode(" Sorry ! "),
        /*#__PURE__*/ _createElementVNode("br"),
        /*#__PURE__*/ _createElementVNode("br"),
        /*#__PURE__*/ _createTextVNode(" Nova Web is not available on mobile devices "),
        /*#__PURE__*/ _createElementVNode("br"),
        /*#__PURE__*/ _createElementVNode("br"),
        /*#__PURE__*/ _createElementVNode("a", {
            href: "https://github.com/YacineSteeve/nova-voicebot-mobile",
            target: "_blank",
            title: "Download Nova Mobile"
        }, "Download "),
        /*#__PURE__*/ _createTextVNode("  "),
        /*#__PURE__*/ _createElementVNode("b", null, "Nova Mobile"),
        /*#__PURE__*/ _createTextVNode(" now ! ")
    ])
], -1));
const _hoisted_3 = [
    _hoisted_2
];
const _hoisted_4 = {
    key: 1,
    class: "other-devices"
};
const _hoisted_5 = { class: "total-center" };
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "main-scroll-overflow" }, null, -1));
import { inject, onMounted } from 'vue';
import { useStore } from '@/store/store';
import { MutationTypes } from '@/store/mutations';
import cookies from '@/lib/cookies';
import FooterSection from '@/components/FooterSection.vue';
import CookieLaw from '@/components/CookieLaw.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'App',
    setup(__props) {
        const store = useStore();
        const isMobile = inject('isMobile', false);
        function getPreferredTheme() {
            const hasDarkPreference = window.matchMedia('(prefers-color-scheme: dark)').matches;
            if (hasDarkPreference) {
                return 'dark';
            }
            else {
                return 'light';
            }
        }
        onMounted(() => {
            const preferredTheme = cookies.isKey('nova-theme')
                ? cookies.get('nova-theme')
                : getPreferredTheme();
            if (cookies.isKey('nova-use-cookies')) {
                cookies.set('nova-theme', preferredTheme);
            }
            document.documentElement.className = `${preferredTheme}`;
            store.commit(MutationTypes.CHANGE_USER_THEME, preferredTheme);
            if (cookies.isKey('nova-language')) {
                store.commit(MutationTypes.CHANGE_LANGUAGE, cookies.get('nova-language'));
            }
        });
        return (_ctx, _cache) => {
            const _component_router_view = _resolveComponent("router-view");
            return (_unref(isMobile))
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
                : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("main", _hoisted_5, [
                        _createVNode(_component_router_view)
                    ]),
                    _hoisted_6,
                    _createVNode(FooterSection),
                    _createVNode(CookieLaw)
                ]));
        };
    }
});
